// extracted by mini-css-extract-plugin
export default {"container":"DropModal_container__vzZhz"};